import type { Versions } from './types';

export function getBuiltinVersions(): Versions {
  return {
    FUEL_CORE: '0.43.1',
    FORC: '0.68.7',
    FUELS: '0.101.3',
  };
}
